var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 9H11.6667V8.33333H4.33333V9ZM4.33333 7H11.6667V6.33333H4.33333V7ZM4.33333 5H11.6667V4.33333H4.33333V5ZM14 13.3846L11.9487 11.3333H3.07692C2.77008 11.3333 2.51389 11.2306 2.30833 11.025C2.10278 10.8194 2 10.5632 2 10.2564V3.07692C2 2.77008 2.10278 2.51389 2.30833 2.30833C2.51389 2.10278 2.77008 2 3.07692 2H12.9231C13.2299 2 13.4861 2.10278 13.6917 2.30833C13.8972 2.51389 14 2.77008 14 3.07692V13.3846ZM3.07692 10.6667H12.2333L13.3333 11.7628V3.07692C13.3333 2.97436 13.2906 2.88034 13.2051 2.79487C13.1197 2.7094 13.0256 2.66667 12.9231 2.66667H3.07692C2.97436 2.66667 2.88034 2.7094 2.79487 2.79487C2.7094 2.88034 2.66667 2.97436 2.66667 3.07692V10.2564C2.66667 10.359 2.7094 10.453 2.79487 10.5385C2.88034 10.6239 2.97436 10.6667 3.07692 10.6667Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.0fbec5137b272164bf706852a2503787.svg";
export { ForwardRef as ReactComponent };